module.exports = __webpack_public_path__ + "img/goods3_6.09fa9659.jpg";